import { useForm } from "react-hook-form";

import useMappings from "../../data/useMappings";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import Modal from "../../layouts/Modal";
import { IPartCategory, IPartMapping } from "../../models/Part";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { NumberInput } from "../shared/Inputs/NumberInput";
import { TextInput } from "../shared/Inputs/TextInput";
import CategoryDetails from "./CategoryDetails";
import { CategoryListingDefaults } from "./CategoryListingDefaults";
import CategoryAspectsDefaults from "./CategoryAspectsDefaults";
import useCategorySingle from "../../data/useCategorySingle";
import LoadingWheel from "../shared/LoadingWheel";


type MappingFormValues = {
  regex: string,
  priority: number
};

interface CategoryModalProps {
  open: boolean,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  category: IPartCategory | undefined,
  categoryId?: string
};

function MappingRow({ mapping, categoryId, setOpen }: { mapping: IPartMapping | null, categoryId: string, setOpen: any }) {
  const { saveHandlers } = useDefaultCRUDHandlers("Part Mapping");
  const { create, update } = useMappings();
  const { register, getValues, setValue, watch, handleSubmit, reset, control } = useForm<MappingFormValues>({
    defaultValues: {
      regex: mapping?.regex,
      priority: mapping?.priority,
    }
  });

  const onSubmit = (data: MappingFormValues) => {
    console.log(data);

    const updatedMapping = {
      partCategoryId: categoryId,
      ...mapping!,
      ...data,
    };

    if (mapping) {
      update.mutate(updatedMapping, saveHandlers);
    } else {
      create.mutate(updatedMapping, saveHandlers);
      reset({});
      setOpen(false);
    }

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-7 gap-x-6">
        <div className="col-span-4">
          <TextInput label="Regex" registerName="regex" register={register} />
        </div>
        <div className="col-span-2">
          <NumberInput label="Priority" registerName="priority" step="1" register={register} />
        </div>
        <ButtonInput label={mapping ? "Save" : "Create"} isSubmit={true} onClick={undefined} classes={"mt-7"} />
      </div>
    </form>
  )
};


export default function CategoryModal({ open, setOpen, category, categoryId }: CategoryModalProps) {
  const selectedCategoryId = category?.id || categoryId;
  const { category: singleCategory, create, update } = useCategorySingle(selectedCategoryId);
  const currentCategory = singleCategory.data?.data || category;

  return (
    <>
      <Modal width="max-w-7xl" open={open} setOpen={setOpen} >
        {category && singleCategory.isLoading && !singleCategory.data ? (
          <LoadingWheel />
        ) : (
          <>
        <div className="flex justify-between items-center">
          <h1 className="text-xl">{`${currentCategory ? "Edit" : "Add"} a Category`}</h1>
          {currentCategory && <ButtonInput label="View Parts" isSubmit={false} onClick={() => window.open(`/parts-editor/${currentCategory.id}`, "_blank", "noreferrer")} classes={undefined} />}
        </div>
        <div className="mt-4">
          <CategoryDetails category={currentCategory} update={update} create={create} open={open} setOpen={setOpen} />
          <br />
          {currentCategory &&
            <CategoryListingDefaults category={currentCategory} />
          }

          {currentCategory?.partCategoryDefaults[0]?.ebayCategoryId && (
            <CategoryAspectsDefaults category={currentCategory} />
          )}

          {currentCategory &&
            <div className="w-full mt-4 space-y-4">
              <h1 className="text-lg">Part Mappings <span className="text-sm"> - Smallest number is highest priority</span></h1>
              <hr />
              {currentCategory.partMappings.map((mapping) => (
                <MappingRow key={mapping.id} mapping={mapping} categoryId={currentCategory.id} setOpen={setOpen} />
              ))}
              <MappingRow mapping={null} categoryId={currentCategory.id} setOpen={setOpen} />
            </div>
          }
        </div>
          </>
        )}
      </Modal>
    </>
  );
};
